import React, { useState } from "react";
import Explainer from "../ExplainerModal";
import landscapingProcess from "../FlowCharts/Landscaping-process.png"; // Importing the flowchart

const PolicyLandscapingExplainer = () => {
  const [isZoomed, setIsZoomed] = useState(false);

  return (
    <Explainer
      title="Policy Landscaping Explainer"
      content={
        <>
          <h3 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "10px", color: "#137A08" }}>
            🌍 Landscaping Overview
          </h3>
          <p>
            Landscaping consists of two sections: <strong>Visualization</strong> and <strong>Data</strong>.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            📊 Visualization
          </h3>
          <p>
            The visualization section includes <strong>Charts</strong> and <strong>Tables</strong>:
          </p>
          <ul>
            <li>📌 <strong>Sunburst Chart</strong> – Displays the number of policies per focal area under each category (Macro, Meso, and Micro).</li>
            <li>📌 <strong>Heatmap Table</strong> – Shows policy presence across countries using green (present) and red (absent) indicators.</li>
            <li>📌 <strong>Overall Score</strong> – A numerical value under agricultural transformation represents progress across all categories.</li>
          </ul>

          {/* 🧮 Score Calculation Section */}
          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            🧮 Score Calculation
          </h3>
          <p>Scores are computed based on responses to focal area questions. Below are the formulas used:</p>

          <h4 style={{ fontSize: "16px", fontWeight: "bold", marginTop: "10px", color: "#333" }}>
            📌 Category Score (Macro, Meso, Micro)
          </h4>
          <p>
            Each category score is calculated as:
          </p>
          <p style={{ backgroundColor: "#f4f4f4", padding: "10px", borderRadius: "5px", fontFamily: "monospace" }}>
            Category Score (%) = (Sum of responses in category ÷ Total questions in category) × 100
          </p>

          <h4 style={{ fontSize: "16px", fontWeight: "bold", marginTop: "10px", color: "#333" }}>
            📌 Landscaping Score
          </h4>
          <p>
            The overall landscaping score is derived from all categories:
          </p>
          <p style={{ backgroundColor: "#f4f4f4", padding: "10px", borderRadius: "5px", fontFamily: "monospace" }}>
            Landscaping Score (%) = (Sum of all responses in Macro, Meso, and Micro ÷ Total number of questions) × 100
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            📝 Data Entry Process
          </h3>
          <p>The following steps outline how to interact with the Landscaping Data section:</p>
          <ol>
            <li>➡️ Navigate to the <strong>Landscaping Data</strong> tab.</li>
            <li>➡️ Click on the <strong>Focal Area</strong> assigned to you.</li>
            <li>🚫 If you are not an <strong>Owner</strong> or <strong>Supervisor</strong>, you will see <em>"You don't have enough permissions."</em> You can only view responses and questions.</li>
            <li>✅ <strong>Owner Responsibilities:</strong>
              <ul style={{ paddingLeft: "20px", marginTop: "5px" }}>
                <li>🖊️ Respond to focal area questions.</li>
                <li>📎 Attach supporting evidence.</li>
                <li>📤 Submit responses for <strong>Supervisor Approval</strong>.</li>
                <li>♻️ Update responses until they are approved.</li>
              </ul>
            </li>
            <li>🔎 <strong>Supervisor Responsibilities:</strong>
              <ul style={{ paddingLeft: "20px", marginTop: "5px" }}>
                <li>📝 Review and approve responses and evidence.</li>
                <li>🌍 Make responses public after approval.</li>
                <li>📢 Provide updates whenever new information becomes available.</li>
              </ul>
            </li>
          </ol>

          <p><strong>Note:</strong> If you are both the <strong>Owner</strong> and <strong>Supervisor</strong>, submitting responses automatically makes them public.</p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            🔄 Landscaping Process Flowchart
          </h3>

          <div style={{ position: "relative", display: "inline-block" }}>
            {/* Flowchart Image */}
            <img
              src={landscapingProcess}
              alt="Landscaping Process Flowchart"
              style={{ width: "100%", borderRadius: "8px", marginTop: "10px", cursor: "pointer" }}
              onClick={() => setIsZoomed(true)}
            />
            {/* Zoom Button (Magnifying Glass) */}
            <button
              onClick={() => setIsZoomed(true)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "rgba(0, 0, 0, 0.7)",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                fontSize: "20px",
                cursor: "pointer"
              }}
            >
              🔍 <span style={{ fontSize: "10px", color: "black" }}>Zoom</span>
            </button>
          </div>

          {/* Zoomed Image Modal */}
          {isZoomed && (
            <div
              style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: "1000"
              }}
              onClick={() => setIsZoomed(false)}
            >
              <img
                src={landscapingProcess}
                alt="Zoomed Landscaping Process Flowchart"
                style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: "8px" }}
              />
            </div>
          )}
        </>
      }
    />
  );
};

export default PolicyLandscapingExplainer;
